module.exports = __webpack_public_path__ + "static/media/amg.5387dc67.png";